<template>
  <div>
    <div
      class="tc-attribution-event-meta d-flex align-items-center justify-content-between"
      style="padding:var(--s-8) var(--s-12);border-bottom:1px solid var(--stroke-1);background:var(--bg-subtle)"
    >
      <span>{{ contextLabel }}</span>
      <button
        v-if="closeable"
        type="button"
        class="tc-btn-icon"
        style="width:20px;height:20px"
        aria-label="Close"
        @click="emit('close')"
      >
        <svg viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path d="M13.5 4.5L4.5 13.5M4.5 4.5l9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <div class="tc-cell-popover-reasoning" style="border-top:none">
      <div class="tc-cell-popover-reasoning-heading">Picked because</div>
      <ul class="tc-cell-popover-reasoning-bullets">
        <li>"Acme Corp" matches this client</li>
        <li>5× similar attributions this period</li>
        <li>Recent @acme.com attendees</li>
      </ul>
      <div class="tc-cell-popover-reasoning-heading">Less sure about</div>
      <ul class="tc-cell-popover-reasoning-bullets">
        <li>Hours — Freshdesk touch was estimated</li>
      </ul>
      <div class="tc-cell-popover-reasoning-heading">Also considered</div>
      <ul class="tc-cell-popover-reasoning-bullets">
        <li>2024-ACME-002 · Implementation</li>
        <li>2024-ACME-001 · Concept</li>
      </ul>
    </div>

    <div
      class="d-flex align-items-center gap-2"
      style="padding:var(--s-8) var(--s-12);border-top:1px solid var(--stroke-1);background:var(--bg-surface)"
    >
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        @click="emit('changeProject')"
      >Change project</button>
      <div style="flex:1"></div>
      <button
        type="button"
        class="btn btn-link btn-sm"
        style="font-size:var(--t-12);padding:0"
        @click="emit('close')"
      >Looks right</button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  contextLabel?: string;
  closeable?: boolean;
}>();

const emit = defineEmits<{
  close: [];
  changeProject: [];
}>();
</script>
